import React, { FC } from 'react';
import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { InvoiceStatus as EInvoiceStatus } from 'common/interfaces/invoices';
import { InvoiceStatuses } from 'common/constants/invoices';

const useStyles = makeStyles((theme: Theme) => ({
  badge: {
    display: 'inline-block',
    padding: '2px 4px',
    borderRadius: '4px',
    color: theme.palette.primary.contrastText,
  },
}));

interface IInvoiceStatus {
  status: EInvoiceStatus;
  className?: string;
}

const InvoiceStatus: FC<IInvoiceStatus> = ({ status, className = '' }) => {
  const classes = useStyles();

  return (
    <Box
      style={{ backgroundColor: InvoiceStatuses.color(status) }}
      className={classNames(classes.badge, {
        [className]: !!className,
      })}
    >
      <Typography color="inherit">{InvoiceStatuses.translate(status)}</Typography>
    </Box>
  );
};

export default InvoiceStatus;
